module.exports = __webpack_public_path__ + "img/flag_report.f5e7bc0d.png";